import api from './client'

export type ProjectVariableKind = 'value' | 'sql' | 'prompt'
export type PromptInputMode = 'input' | 'select'

export interface ProjectVariable {
  name: string
  kind: ProjectVariableKind
  value: string
  description: string
  // ── Prompt-kind (ask-the-logged-in-user) fields ───────────────────────
  // Only meaningful when kind === 'prompt'.
  input_mode?: PromptInputMode
  prompt?: string
  default?: string
  required?: boolean
  external?: boolean
  remember_default?: boolean
  /** Pick-from-a-list options chosen from a TABLE instead of written as SQL.
   *  The server compiles it into `value` on save. */
  source?: ProjectVariableTableSource | null
  /** "Use in rights model": the user's pick decides which entity-specific
   *  roles apply (context-based security). At most one per project. */
  security_context?: boolean
}

export interface ProjectVariableTableSource {
  type: 'table'
  table: string
  value_column: string
  label_column?: string
  filter?: string
  order_by?: string
}

export interface OptionsPreview {
  ok: boolean
  options: { value: string; label: string }[]
  total?: number
  sql: string
  error?: string
}

/** Run a selection list against the project's data and return its first rows. */
export async function previewProjectVariableOptions(
  projectId: string, body: { source?: ProjectVariableTableSource | null; value?: string },
): Promise<OptionsPreview> {
  const res = await api.post(
    `/project-variables/${encodeURIComponent(projectId)}/preview-options`, body,
  )
  return res.data as OptionsPreview
}

export async function listProjectVariables(
  projectId: string,
): Promise<ProjectVariable[]> {
  const res = await api.get(
    `/project-variables/${encodeURIComponent(projectId)}`,
  )
  return (res.data?.variables || []) as ProjectVariable[]
}

export async function saveProjectVariables(
  projectId: string,
  variables: ProjectVariable[],
): Promise<ProjectVariable[]> {
  const res = await api.put(
    `/project-variables/${encodeURIComponent(projectId)}`,
    { variables },
  )
  return (res.data?.variables || []) as ProjectVariable[]
}
